import type React from "react";
import { Table } from "./table";

interface SeasonProps {
  heading: string;
  record: {
    item: string;
    info: string;
    description?: {
      heading: string;
      content: string;
    };
  }[];
}

export const Season: React.FC<SeasonProps> = ({ heading, record }) => {
  return (
    <div className="px-[23px] flex flex-col items-start gap-5 w-full">
      {/* Heading */}
      <div>
        <h2 className="text-[22px] font-bold text-black">{heading}</h2>
      </div>
      {/* Scores */}
      <div className="grid sm:grid-cols-6 grid-cols-3 w-full ">
        {record.map((score, index) => {
          return (
            <div key={score.item || index} className="col-span-1">
              {/* Item */}
              <Table
                name={score.item}
                description={score.description}
                className={`h-[44px] bg-[#ECECEC] border-white border-solid ${index !== 0 && "border-l"}`}
              />
              {/* Info */}
              <Table
                name={score.info}
                className={`h-[44px]  border-gray-200 border-solid ${index === 0 ? "border-l" : ""} border-b border-r`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
